import {signal, WritableSignal} from '@angular/core';

export const googleAnalyticsDebugSignal: WritableSignal<boolean> = signal<boolean>(false);
